import { createSelector } from 'reselect';


const getCustomersState = (state: Object): Object => state.customers;

export const getCustomers = createSelector([getCustomersState], customer => customer.customers);
export const isFetchingCustomers = createSelector([getCustomersState], customer => customer.fetching);
export const hasError = createSelector([getCustomersState], customer => customer.error);



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/selectors/customerSelectors.js